import React from "react"
import PropTypes from 'prop-types'

const Body = ({
  id, children, className, textColor, font = 'font-body'
}) => {
  return (
    <p className={`${textColor || 'text-copy'} text-sm ${font} ${className}`} id={id}>
      {children}
    </p>
  )
}
Body.prototype = {
  id: PropTypes.string,
  children: PropTypes.string,
  className: PropTypes.string,
  textColor: PropTypes.string,
  font: PropTypes.string
}

export default Body
